import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import state, { IUiState }  from './state'
import { Module } from 'vuex/types'
import { IRootState } from '@/store'

const uiModule: Module<IUiState, IRootState> = {
  actions,
  getters,
  mutations,
  state
}
export default uiModule
